var $ = jQuery;
$(function(){
// 超出关闭
$(document).on('click', '.sunber-wheel-poupop-con', function (e) {
  // 判断点击的目标是否在 .wheel-poupop 里面
  if ($(e.target).closest('.wheel-poupop').length === 0) {
    // 如果点到的是空白区域（不是 .wheel-poupop 内部）
    $('.sunber-wheel-poupop-con').hide();
    console.log("点击了空白区域，关闭弹窗");
    // GAwheelPopClickClose(); 
  }
});
$(document).on('click', '.three-hundred-voucher-package-con', function (e) {
  // 判断点击的目标是否在子盒子 .three-hundred-voucher-package 内
  if ($(e.target).closest('.three-hundred-voucher-package').length === 0) {
    // 如果点到的是空白区域（不是子盒子内部）
    // $('.three-hundred-voucher-package-con').hide();
    console.log("点击空白区域，关闭父盒子17");
    // 点击关闭，触发埋点
    const ec_name = 'popUp'
    var path_c = window.location.pathname; 
    console.log('path:',path_c);
    console.log('cleanPath',path_c);

    console.log(path_c);
    const ec_categroy = '$'+ path_c;
    const ec_action = 'popUp_Click';
    const ec_label = 'popUp::TurnTable_'+path_c+'::Close';
    const ec_remarks = 'clickPop'
    console.log('1:',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label,'5',ec_remarks);

    // 调用 datalayer 方法
    window.datalayer_popup_even_c({
      event_name: ec_name,
      event_category: ec_categroy,
      event_action: ec_action,
      event_label: ec_label,
      event_remarks: ec_remarks
    });

    const StayContainerCon = sessionStorage.getItem("threeHundredVoucherPackageStayContainerCon");
    console.log(StayContainerCon,'挽留弹窗标识17');
    
    if (StayContainerCon) {
      $('.three-hundred-voucher-package-con').css('display','none');
      $('.all-voucher-package-enter-slider').css('display','block')
    }else{
      $('.three-hundred-voucher-package-con .stay-container-con').css('display','block');
      $('.three-hundred-voucher-package-con .container-con').css('display','none');
      $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','none');
    }



  }
});

$(document).on('click', '.all-voucher-package-con', function (e) {
  // 判断点击的目标是否在子盒子 .three-hundred-voucher-package 内
  if ($(e.target).closest('.all-voucher-package').length === 0) {
    // 如果点到的是空白区域（不是子盒子内部）
    $('.all-voucher-package-con').hide();
    console.log("点击空白区域，关闭父盒子");
  }
});


function sliderWheelGetItCheckout() {
  let res = sessionStorage.getItem("popuManageResponse");
   if (!res) {
    return;
  }
  let obj = JSON.parse(res);
  // const waitingTime =obj.length[0].content.pop_seconds
  const wheelStatus = obj.data[0].status
  const threeStatus = obj.data[1].status
  console.log('转盘和券包的开关状态1020',wheelStatus,threeStatus);
  


  const voucherPackageGetIt = sessionStorage.getItem("threeHundredVoucherPackageGetIt");
  const voucherPackageGetItClose = sessionStorage.getItem("threeHundredVoucherPackageGetItClose");
  const wheelPoupopConSidebarClose = sessionStorage.getItem("sunberWheelPoupopConSidebarClose");
  // const voucherPackageGetItClickView = sessionStorage.getItem("threeHundredVoucherPackageStayContainerCon");
  // const voucherPackageGetItRightClickView = sessionStorage.getItem("threeHundredVoucherPackageGetIt");

  console.log('git关闭状态',voucherPackageGetItClose);
  console.log('git状态',voucherPackageGetIt);
  // 先处理领取状态
  if (voucherPackageGetItClose && voucherPackageGetIt) {
    // 优先关闭状态，全部隐藏
    console.log("用户已关闭弹窗，隐藏所有弹窗1");
    $('.sunber-wheel-poupop-con-sidebar').hide();
    $('.all-voucher-package-enter-slider, .sunber-wheel-poupop-con-sidebar').hide();
  } else if (voucherPackageGetIt) {
    // 已领取但未关闭，底部显示，侧边隐藏
    console.log("用户已领取，显示底部弹窗，隐藏侧边栏22:",$('.sunber-wheel-poupop-con-sidebar').length);
    if (threeStatus == '1') {
      console.log("底部300入口判断");
      $('.all-voucher-package-enter-slider').show();
     }
    $('.sunber-wheel-poupop-con-sidebar').hide();
  } else {
    // 都不存在，默认侧边显示 检测下转盘接口开关
    console.log("未领取，显示侧边栏3 ");
    if (wheelStatus == '1') {
      console.log("侧边转盘入口判断");
      if (!wheelPoupopConSidebarClose) {
        console.log('执行了侧边显示109',wheelPoupopConSidebarClose);
        $('.sunber-wheel-poupop-con-sidebar').show();
      }
     }
      $('.all-voucher-package-enter-slider').hide();


  }

  // if (voucherPackageGetItClickView || voucherPackageGetItRightClickView) {
  //   if (threeStatus == '1') {
  //     console.log("底部300入口判断");
  //     $('.all-voucher-package-enter-slider').show();
  //    }
  // }

  
}




  
// -======================-=-=-关闭转盘，调出300券包 1=-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-

  $('.sunber-wheel-poupop-con .wheel-spin-box-close-x').on('click',function () {
    console.log('点击触发关闭弹窗');
    wheelPoupopNone();
    // 执行侧标栏标识位置

    // 后通过浏览器会话窗口计时40秒后打开300券包，一天执行一次 执行弹出啊300 券包弹窗  
    // 从会话存储获取后端数据
    let sessionStorageRes = sessionStorage.getItem("popuManageResponse");
    if (!sessionStorageRes) {
        console.log('没有存储的数据，退出方法');
        return;
        return;
    }

    let sessionStorageObj = JSON.parse(sessionStorageRes);
    // const activity_id = sessionStorageObj.data[0].content.reward_activity_id;
    // const star_pop_seconds = sessionStorageObj.data[0].content.star_pop_seconds; // 倒计时总秒数
    const pop_seconds = sessionStorageObj.data[1].content.pop_seconds; // 弹窗渲染时间（秒）
    const pop_seconds_name = sessionStorageObj.data[1].name; // 弹窗渲染时间（秒）
    const renderingTime = pop_seconds * 1000; // 转换为毫秒

    // console.log("打印会话存储的id✅✅", activity_id);
    // console.log("打印 star_pop_seconds ✅✅", star_pop_seconds);
    console.log("打印 pop_seconds ✅✅",pop_seconds_name,':', pop_seconds);


    // 检测
    // 获取用户邮箱判断登录状态
      const userEmail = window.customerData?.email; // 检测是否登录
      const wheelPoupopPostSuccess = sessionStorage.getItem("wheelPoupopPostSuccess"); // 检测是否注册过弹窗/活动
      const postSuccess = sessionStorage.getItem("wheelPoupopPostSuccess");

      // -=-=-=-=-=-==-=
      // function startCountdown(pop_seconds) {
        const storageKey = "pop_seconds_end_time";
        let endTime = sessionStorage.getItem(storageKey);
      
        if (!endTime) {
          // 第一次进来：存一个300券包结束时间
          endTime = Date.now() + pop_seconds * 1000;
          sessionStorage.setItem(storageKey, endTime);
          console.log("⏳ 第一次设置倒计时，结束时间:", new Date(parseInt(endTime)).toLocaleString());
        } else {
          endTime = parseInt(endTime);
          console.log("📦 从会话窗口取到结束时间:", new Date(endTime).toLocaleString());
        }
      
        // 每秒检查一次
        
        
        // const interval = setInterval(() => {
        //   const now = Date.now();
        //   const remainSec = Math.ceil((endTime - now) / 1000);
        
        //   if (remainSec <= 0) {
        //     clearInterval(interval);
        //     console.log("✅ 倒计时结束，执行逻辑");
        //     if ($('.sunber-wheel-poupop-con').css('display') === 'block') {
        //       console.log("⚠️ 转盘弹窗正在显示...");
        //       $('.sunber-wheel-poupop-con .wheel-spin-box-close-x')
        //         .off('click') // 先解绑，避免重复
        //         .on('click', function () {
        //           show();
        //         });
        //     } else {
        //       console.log("✅ 转盘弹窗未显示，可以继续逻辑");
        //       show();
        //     }

        //     sessionStorage.removeItem(storageKey); // 用完清掉，避免重复
        //   } else {
        //     console.log(`⏱️ 300券包倒计时剩余 ${remainSec} 秒`);
        //   }
        // }, 1000);
      // }
      let res = sessionStorage.getItem("popuManageResponse");
        if (res) {
            let obj = JSON.parse(res); // 转回对象
            // console.log("📦 存储的数据为：", obj.data);
        }
        let obj = JSON.parse(res);
        // const waitingTime =obj.length[0].content.pop_seconds
        const wheelStatus = obj.data[0].status
        const threeStatus = obj.data[1].status
        console.log('转盘和券包的开关状态168',wheelStatus,threeStatus);
    
        if (threeStatus == '1') {threeDowmTimeSetInterval()}

  })

    // 把执行券包独立出来
    threeDowmTimeSetInterval()
  function threeDowmTimeSetInterval() {
    //   const storageKey = "pop_seconds_end_time";
    //   const endTimeStr = sessionStorage.getItem(storageKey);
    
    //   if (endTimeStr) {
    //     const endTime = parseInt(endTimeStr, 10);
    //     console.log("📦 300券包有结束时间，结束时间为:", new Date(endTime).toLocaleString());




    //   } else {
    //     console.log("⚠️ 券包还没有存结束时间");
    //   }
      
    
    
      const storageKey = "pop_seconds_end_time";
      const endTimeStr = sessionStorage.getItem(storageKey);
    
      if (endTimeStr) {
        // 转回数字
        const endTime = parseInt(endTimeStr, 10);
        console.log("📦 有结束时间，结束时间为:", new Date(endTime).toLocaleString());
    
        // ===== 倒计时逻辑 =====
        const interval = setInterval(() => {
          const now = Date.now();
          const remainSec = Math.ceil((endTime - now) / 1000);
    
          if (remainSec <= 0) {
            clearInterval(interval);
            console.log("✅ 倒计时结束，执行逻辑");
    
            if ($('.sunber-wheel-poupop-con').css('display') === 'block') {
              console.log("⚠️ 转盘弹窗正在显示...");
              $('.sunber-wheel-poupop-con .wheel-spin-box-close-x')
                .off('click') // 先解绑，避免重复
                .on('click', function () {
                  show();
                });
            } else {
              $('.sunber-wheel-poupop-con-sidebar').hide();
              console.log("✅ 转盘弹窗未显示，可以继续逻辑");
              show();
            }
    
            sessionStorage.removeItem(storageKey); // 用完清掉
          } else {
            // console.log(`⏱️ 300券包倒计时剩余 ${remainSec} 秒`);
            // console.log('执行了侧边显示275');
            // $('.sunber-wheel-poupop-con-sidebar').show();
            const wheelPoupopConSidebarClose = sessionStorage.getItem("sunberWheelPoupopConSidebarClose"); 
            if (!wheelPoupopConSidebarClose) { 
              console.log('show执行了侧边显示275');
              $('.sunber-wheel-poupop-con-sidebar').show(); }
            // // $('.sunber-wheel-poupop-con-sidebar').show();
            // const wheelPoupopConSidebarClose = sessionStorage.getItem("sunberWheelPoupopConSidebarClose"); 
            // if (!wheelPoupopConSidebarClose) { 
            //   console.log('show执行了侧边显示275');
            //   $('.sunber-wheel-poupop-con-sidebar').show(); }
            
          }
        }, 1000);
    
      } else {
        console.log("⚠️ 还没有存结束时间");
      }
    
  }
    
    


    // =-=-=-=-==-=-=
    
      function show() {
        // 先给侧边隐藏
        $('.sunber-wheel-poupop-con-sidebar').css('display','none');
        const wheelPoupopPostSuccess = sessionStorage.getItem("wheelPoupopPostSuccess"); // 检测是否注册过弹窗/活动
        const postSuccess = sessionStorage.getItem("wheelPoupopPostSuccess");
        // 如果未注册触发
        if (!postSuccess) {
          console.log("打印用户是否注册结果", postSuccess);
        
          // 未登录且未触发过
          if (!userEmail && !wheelPoupopPostSuccess) {
              console.log("用户未登录且未触发过弹窗，调用活动接口");
              // 检测后台300开关
               // / 把数据从会话窗口中拿出
                let res = sessionStorage.getItem("popuManageResponse");
                if (res) {
                    let obj = JSON.parse(res); // 转回对象
                    // console.log("📦 存储的数据为：", obj.data);
                }
                let obj = JSON.parse(res);
                // const waitingTime =obj.length[0].content.pop_seconds
                const wheelStatus = obj.data[0].status
                const threeStatus = obj.data[1].status
                console.log('转盘和券包的开关状态259',wheelStatus,threeStatus);
              if (threeStatus == '1') {
                console.log("后台300券包开关开启");
                
                threeHundredVoucherPackage(); // 或你的弹窗方法
               $('.three-hundred-voucher-package-con .stay-container-con').css('display','none'); 
                $('.three-hundred-voucher-package-con .container-con').css('display','block');
                $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','block'); // 显示关闭按钮
                $('.sunber-wheel-poupop-con').css('display','none'); // 关闭转盘弹窗
                $('.sunber-wheel-poupop-con-sidebar').css('display','none'); // 关闭转盘弹窗

                const e_name = 'popUp'
                var path = window.location.pathname; 
                console.log('path:',path);
                console.log('cleanPath',path);
                
                console.log(path);
                const e_categroy = '$'+ path;
                const e_action = 'popUp';
                const e_label = 'popUp::NewUser_'+path+'::view';
                const e_remarks = 'autoPop'
                console.log('1:',e_name,'2',e_categroy,'3',e_action,'4',e_label,'5',e_remarks);
    
                // 调用 datalayer 方法  
                window.datalayer_popup_even_n({
                  event_name: e_name,
                  event_category: e_categroy,
                  event_action: e_action,
                  event_label: e_label,
                  event_remarks: e_remarks
                });



              }

              // $('.all-voucher-package-enter-slider').css('display','block')
          } else {
              console.log("用户已登录或弹窗已触发，不调用",userEmail,wheelPoupopPostSuccess);
          }
        
        }else{
          console.log("用户已注册过活动，不用打开300券包弹窗",postSuccess);
          $('.sunber-wheel-poupop-con').css('display','none'); // 关闭转盘弹窗
        
        }
      }


    // threeHundredVoucherPackage(); // 调用300券包
// -======================-=-=-关闭转盘，调出300券包=-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-
    const wheelPostSuccess = sessionStorage.getItem("wheelPoupopPostSuccess");
    if (wheelPostSuccess) {
      runRegisterCountdown(); // 继续倒计时

        // console.log("用户转盘登录成功刷新之后调用注册奖励倒计时结束 🎉");
        // $('.sunber-wheel-poupop-con-sidebar').hide();
        //   sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
        //   sessionStorage.setItem("threeHundredVoucherPackageGetItClose", "true");
     

    }
  // 接口管理 
  // 🔽 请求弹窗管理接口
  popupManage()
  function popupManage() {
      $.ajax({
        url: "http://plugin.kriyya.com/api/sunber/popup_manage",
        method: "GET",
        timeout: 0, // 设个超时时间
        headers: {
          "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
        },
        success: function (response) {
          console.log("✅ 300成功响应：", response);
          // 储存到浏览器的会话窗口中
          sessionStorage.setItem("popuManageResponse",JSON.stringify(response))
          console.log(response, '返回数据4', response.data[1].content.packges);
          // 获取转盘电话弹窗的显示与隐藏
          console.log(response, '电话开关数据', response.data[0].content.register_type);
          if (response.data[0].content.register_type === '2') {
            console.log('执行电话显示');
            $('.sunber-wheel-poupop-inner .round-number-input').css('display','block');
          }else{
              $('.wheel-poupop-position-round .round-input-email').addClass('round-input-email-add-bot');
          }

          const packages = response.data[1].content.packges;
          const threeStatus = response.data[1].status
        // 判断300券包开关 后端开关关闭 得传数据，
          if (threeStatus == '1') {
            // 移除侧边 的透明度
            $('.all-wheel-poupop-voucher-package-alter .sunber-wheel-poupop-con-sidebar').removeClass('disabled')
            const $ulCoupon = $('.all-voucher-package-con .coupon-con .ul-coupon');
            
            $ulCoupon.empty(); // 清空原来的 li
            
            packages.forEach(item => {
              const liHtml = `
                <li class="li-coupon post-response-data-ul">
                  <div class="left">
                    <div class="left-in">
                      <p class="p-top">Save</p>
                      <p class="p-bot">${item.title}</p>
                    </div>
                  </div>
                  <div class="right">
                    <div class="right-in">
                      <p class="p-top">${item.sub_title}</p>
                      <p class="p-bot">CODE:<span class="code">${item.code}</span>
                        <i class="icon-info">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M9.77084 5.65845C9.77084 5.32453 9.7707 5.10017 9.75659 4.92757C9.74633 4.80201 9.72989 4.72558 9.71102 4.67293L9.69108 4.62736C9.6299 4.50731 9.53701 4.40688 9.42277 4.33683L9.37264 4.30892C9.31983 4.28201 9.23985 4.2571 9.07243 4.24341C8.89984 4.22931 8.67547 4.22917 8.34156 4.22917H3.61678C3.28287 4.22917 3.0585 4.22931 2.88591 4.24341C2.76035 4.25367 2.68391 4.27012 2.63127 4.28898L2.5857 4.30892C2.46564 4.3701 2.36522 4.46299 2.29517 4.57723L2.26726 4.62736C2.24034 4.68018 2.21543 4.76016 2.20174 4.92757C2.18764 5.10017 2.1875 5.32453 2.1875 5.65845V10.3832C2.1875 10.7171 2.18764 10.9415 2.20174 11.1141C2.21543 11.2815 2.24034 11.3615 2.26726 11.4143L2.29517 11.4644C2.36522 11.5787 2.46564 11.6716 2.5857 11.7327L2.63127 11.7527C2.68391 11.7716 2.76035 11.788 2.88591 11.7983C3.0585 11.8124 3.28287 11.8125 3.61678 11.8125H8.34156C8.67547 11.8125 8.89984 11.8124 9.07243 11.7983C9.23985 11.7846 9.31983 11.7597 9.37264 11.7327L9.42277 11.7048C9.53701 11.6348 9.6299 11.5344 9.69108 11.4143L9.71102 11.3687C9.72989 11.3161 9.74633 11.2397 9.75659 11.1141C9.7707 10.9415 9.77084 10.7171 9.77084 10.3832V5.65845ZM11.8125 9.625V5.48356C11.8125 4.82299 11.8123 4.35362 11.7823 3.98649C11.7564 3.66965 11.71 3.45836 11.6382 3.2915L11.6057 3.22258C11.4467 2.91047 11.2049 2.64934 10.9079 2.4672L10.7774 2.39429C10.5998 2.30379 10.3755 2.24727 10.0135 2.21769C9.64638 2.1877 9.17701 2.1875 8.51644 2.1875H4.375C4.13338 2.1875 3.9375 1.99163 3.9375 1.75C3.9375 1.50838 4.13338 1.3125 4.375 1.3125H8.51644C9.16255 1.3125 9.6737 1.31197 10.0847 1.34554C10.5008 1.37954 10.853 1.45065 11.1745 1.61442L11.3653 1.72152C11.7994 1.98774 12.1531 2.36931 12.3856 2.82552L12.4425 2.94743C12.5664 3.23593 12.6247 3.55112 12.6545 3.91528C12.688 4.3263 12.6875 4.83745 12.6875 5.48356V9.625C12.6875 9.86663 12.4916 10.0625 12.25 10.0625C12.0084 10.0625 11.8125 9.86663 11.8125 9.625ZM10.6458 10.3832C10.6458 10.7027 10.6464 10.9688 10.6287 11.1853C10.6129 11.3792 10.5806 11.5627 10.5057 11.7373L10.471 11.8114C10.3364 12.0755 10.1315 12.2964 9.88021 12.4505L9.7697 12.5126C9.57303 12.6128 9.36515 12.6523 9.14364 12.6704C8.92715 12.6881 8.66103 12.6875 8.34156 12.6875H3.61678C3.2973 12.6875 3.03119 12.6881 2.8147 12.6704C2.62081 12.6546 2.43734 12.6223 2.2627 12.5474L2.18864 12.5126C1.92451 12.378 1.70361 12.1732 1.54948 11.9219L1.48739 11.8114C1.38722 11.6147 1.34769 11.4068 1.32959 11.1853C1.3119 10.9688 1.3125 10.7027 1.3125 10.3832V5.65845C1.3125 5.33897 1.3119 5.07286 1.32959 4.85636C1.34769 4.63485 1.38722 4.42697 1.48739 4.23031L1.54948 4.11979C1.70361 3.86848 1.92451 3.66363 2.18864 3.52905L2.2627 3.4943C2.43734 3.4194 2.62081 3.3871 2.8147 3.37126C3.03119 3.35357 3.2973 3.35417 3.61678 3.35417H8.34156C8.66103 3.35417 8.92715 3.35357 9.14364 3.37126C9.36515 3.38936 9.57303 3.42889 9.7697 3.52905L9.88021 3.59115C10.1315 3.74528 10.3364 3.96618 10.471 4.23031L10.5057 4.30436C10.5806 4.47901 10.6129 4.66247 10.6287 4.85636C10.6464 5.07286 10.6458 5.33897 10.6458 5.65845V10.3832Z" fill="black" />
                            </svg>
                        </i>
                      </p>
                    </div>
                  </div>
                 
                </li>
              `;
              $ulCoupon.append(liHtml);
            });
            
          }
          

          postDailyData();
        },
        error: function (xhr, status, error) {
          console.error("❌ 请求失败：", status, error);
        }
      });
    }
    //  🔽 抽奖请求
    function lotteryStart(id,email,phone) {
      console.log("请求抽奖结果",id,email,phone);
      var form = new FormData();
      form.append("activity_id",id)
      if (phone) {
        form.append("email",email)
        form.append("phone",phone)
      }else{
        form.append("email",email)
      }

     
      $.ajax({
        "url":"https://plugin.kriyya.com/api/sunber/reward/start",
        "method":"POST",
        "timeout":0,
        "headers":{
          "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
        },
        "processData":false,
        "mimeType":"multipart/form-data",
        "contentType":false,
        "data":form,
        success:function (lotteryRes) {
          console.log('✅成功响应抽的奖项',lotteryRes);
          // 存储转盘中奖奖项

          
          let obj = JSON.parse(lotteryRes);
          // const waitingTime =obj.length[0].content.pop_seconds
          const code = obj.code
          const message = obj.message
          console.log("打印code✅",code);
          console.log("打印message✅",message);
         
          
          if (obj.login_url) {
            // 成功
            console.log('注册成功520');
            
            // 把转盘抽奖结果存入会话窗口
            sessionStorage.setItem("wheelPoupopPostSuccess", "true");

            // 执行关闭弹窗
            stopWheelSpin();
            // 打开转盘遮盖，显示抽奖结果
            lotteryInformation(obj)
         }else if (obj.code === 500) {
            
            if (obj.message === 'has already been taken') {
              console.log("邮箱重复");
              messageError('The Email Has Been Registered, Please Log In')
            }
            let msgObj = {};
            try {
              msgObj = JSON.parse(obj.message); // 👈 再解析一层
            } catch (e) {
              console.error("❌ message 解析失败:", e, obj.message);
            }
          
            console.log("msgObj 类型:", typeof msgObj);
            console.log("msgObj 值2:", msgObj);
            console.log('打印下phone的内容',msgObj.errors.phone[0]);
            const msgErrorPhone = msgObj.errors.phone[0]

            // ✅ 然后这样判断
            if (msgObj.errors?.phone?.[0] === "is invalid") {
              console.log("📵 电话号不合法");
              messageError('Please enter a valid iphone')
            }else if(msgObj.errors?.email?.[0] === 'is invalid' ){
              console.log('邮箱不符合规范，单独提示邮箱', obj);
              messageError('Please enter a valid email');
            }else if ( msgObj.errors?.phone?.[0] === 'is invalid' && msgObj.errors?.email?.[1] === 'is invalid'){
              console.log('两个同时提示，邮箱电话都不符合规范', obj);
                messageError('The email address or phone number already exists')
            }else if ( msgObj.errors?.email?.[0] ===  "has already been taken" ){
              console.log('两个同时提示，邮箱重复，电话基本符合规范', obj);
              messageError('The email address or phone number already exists')
            }else if( msgObj.message?.errors?.phone?.[0] ===  "has already been taken" ){
              console.log('邮箱不重复，电话号重复，', obj);
              messageError('The iphone is Registered please try again.')
            }else if(obj.code === 500 && obj.message==="has already been taken") {
              console.log('邮箱重复', obj);
              messageError('The Email Has Been Registered, Please Log In')
            }else if(msgObj?.errors?.phone?.[0] === "has already been taken"){
              console.log("📞 这个手机号已经被注册过了");
              messageError('The iphone is Registered please try again.')
            }else{
              console.log('两个同时提示，邮箱电话都不符合规范');
              messageError('The email address or phone number already exists')
            }  
          }else{
            console.log('两个同时提示，邮箱电话都不符合规范');
            messageError('The email address or phone number already exists')
          }          


            function messageError(errorMes) {
              // 未成功
              console.log("你已经注册过当前邮箱了ddfda@ll.com");
              // 执行关闭弹窗
              stopWheelSpin();
              // 执行弹出错误信息
              $('.wheel-poupop-position-round .pleaseprovideavalidemailaddress_span').text(errorMes); // 清空输入框内容
              $('.wheel-poupop-position-round .pos-round-error-alter')
              .addClass('pos-round-error-alter-block') // 添加类，显示出来
              .show(); // 确保 display 被设为 block（如果类里没设的话）
  
  
              // 3秒后移除类并隐藏
              setTimeout(function () {
                $('.wheel-poupop-position-round .pos-round-error-alter')
                  .removeClass('pos-round-error-alter-block')
                  .hide();
              }, 3000);
              // return;
           }

        }
      }) 
    }
  // 300券包注册请求
  // threeHundredVoucherPackage(); 
  function threeHundredVoucherPackagePost(email,phone) {
    console.log(">>> 触发300券包请求,发送邮箱和电话号", email, phone);

      var form = new FormData();
      if (phone) {
        form.append("email",email)
        form.append("phone",phone )
      }else{
        form.append("email",email)
      }
     
      console.log("打印form数据",form);
      
      $.ajax({
        "url":"https://plugin.kriyya.com/api/sunber/coupon_package_register",
        "method":"POST",
        "timeout":0,
        "headers":{
          "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
        },
        "processData":false,
        "mimeType":"multipart/form-data",
        "contentType":false,
        "data":form,
        success:function (res) {
          console.log("✅ 成功响应300券包请求:执行打开券包列表", res);
          $('.voucher-package-email-click-register').css("background" ,"#000");
          $('.voucher-package-email-click-register .but-text').removeClass('but-text-none');
          $('.voucher-package-email-click-register .spinner').removeClass('load-spinner');
          // 1.把成功的结果传到会话窗口， 
          // 2.执行:如果成功，或者上次已注册成为用户，直接打开券列表
          //3.后续如果不成功，再点击300券包的关闭按钮的时候，检测会话窗口的挽留弹窗里面是否有数据
          // 如果没有数据，弹窗挽留弹窗，没有数据直接关闭
          // 4.点击关闭挽留弹窗，记录一下，放在会话窗口
          // 5.点击300券包入口，优先检测是否登录，登录就直接打开全列表，
          // 如果没登录，检测会话窗口是否有成功数据，有就执行券列表弹窗， 没有就执行注册300弹窗
           // 判断返回结构
           // 如果返回是字符串，先转对象
             // 如果返回是字符串，先转 JSON
            if (typeof res === "string") {
              try {
                res = JSON.parse(res);
              } catch (e) {
                console.error("返回值不是有效 JSON:", res);
                // return;
              }
            }
            if (res.login_url) {
              console.log("返回了登录链接2:300success", res.login_url);
              // 给侧边隐藏,底部显示标识
              sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
              // const voucherPackageGetItClose = sessionStorage.getItem("threeHundredVoucherPackageGetItClose");
              sessionStorage.setItem("voucherPackageGetItClose", "false");
              // 注册成功位置埋点
               // 点击登录成功，触发埋点
                const ec_name = 'register_success'
                var path_c = window.location.pathname; 
                console.log('path:',path_c);
                var userId = $('#MainContent').data('ud');  
                console.log("User ID:", userId);
                        
                const ec_categroy = '$'+ path_c;
                const ec_action = 'click';
                const ec_label = 'register_success';
                const ec_remarks = 'sunber大额优惠券';
                const idc_login = userId;
                console.log('1:',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label,'5',ec_remarks,'6用户id',idc_login);
                        
                // 调用 datalayer 方法
                window.datalayer_popup_even_c_login({
                  event_name: ec_name,
                  event_category: ec_categroy,
                  event_action: ec_action,
                  event_label: ec_label,
                  event_remarks: ec_remarks,
                  login_id:idc_login
                });
              sessionStorage.setItem("threeHundredVoucherPackagePostSuccess", "true");
              sessionStorage.setItem("threeHundredVoucherPackagePostSuccessLogin", res.login_url);
              // 展示券包列表，并直接赋值 href
              $('.three-hundred-voucher-package-con ').css('display','none')
              $('.all-voucher-package-con').css('display','block');
              // $('.all-voucher-package-con .all-voucher-package .row2-but .but-a-text')
              //   .attr("href", res.login_url);
                // 生成新的 a 标签
              //   const linkA = res.login_url
              // const newLink = `<a href="${linkA}" class="but-a-text" style="transition: none;">Shop Now</a>`;

              // // 覆盖原来的 a 标签
              // $LinkContainer.html(newLink);
              // sessionStorage.setItem("threeHundredVoucherPackagePostSuccess", "true");
          
            }else if ( res.code === 500 &&
              res.message?.email?.[0] ===  "is invalid"){
                console.log('邮箱不符合规范，单独提示邮箱', res);
                threeHundredVoucherPackagePostErrorsEmail('Please enter a valid email ');
              }
              else if	( res.code === 500 &&
            	  res.message?.phone?.[0] ===  "is invalid" &&  res.message?.email?.[1] ===  "is invalid"){
                  console.log('两个同时提示，邮箱电话都不符合规范', res);
                  threeHundredVoucherPackagePostErrors('The email address or phone number already exists')
              }
              else if ( res.code === 500 &&
                res.message?.email?.[0] ===  "has already been taken"){
                  console.log('两个同时提示，邮箱重复，电话基本符合规范', res);
                  threeHundredVoucherPackagePostErrors('The email address or phone number already exists')

                  
                  // 如果已存在，可以选择清空或保持上一次的 login_url
                  // sessionStorage.setItem("threeHundredVoucherPackagePostSuccessLogin", "");

              }
                else if ( res.code === 500 &&
                  res.message?.phone?.[0] ===  "is invalid"){
                    console.log('电话号基本不符合规范，邮箱重复或者不重复', res);
                    threeHundredVoucherPackagePostErrorsPhone('Please enter a valid iphone')
              }
                else if 	( res.code === 500 &&
                  res.message?.phone?.[0] ===  "has already been taken"){
                    console.log('邮箱不重复，电话号重复，', res);
                    threeHundredVoucherPackagePostErrorsPhone('The iphone is Registered please try again.')
              }




        },
        error:function (err) {
          console.error("❌ 请求失败", err);
        reject(err); // 把错误传出去
        }


      })
    
    
  }


  // 注册300券包报错提示
  // 两个同时提示，方法
  function threeHundredVoucherPackagePostErrors(errorMessage) {
    $('.three-hundred-voucher-package .error-email').text(errorMessage);
    $('.three-hundred-voucher-package .error-email').show();
    $('.three-hundred-voucher-package-con .row2 .before-i').css('display','block');
    $('.three-hundred-voucher-package-con .row2 .round-input-email').css('border','1.5px red solid');

    $('.three-hundred-voucher-package .error-phone-number').text(errorMessage);
      $('.three-hundred-voucher-package .error-phone-number').show();
      $('.three-hundred-voucher-package-con .row2 .round-number-input .before-i').css('display','block');
      $('.three-hundred-voucher-package-con .row2 .round-number-input').css('border','1.5px red solid');
      setTimeout(() => {
        $('.three-hundred-voucher-package .error-phone-number').hide();
        $('.three-hundred-voucher-package-con .row2 .round-number-input .before-i').css('display','none');
        $('.three-hundred-voucher-package-con .row2 .round-number-input').css('border','1.5px #D1D5D9 solid');
        $('.three-hundred-voucher-package .error-email').hide();
        $('.three-hundred-voucher-package-con .row2 .before-i').css('display','none');
        $('.three-hundred-voucher-package-con .row2 .round-input-email').css('border','1.5px #D1D5D9 solid');
      }, 10000);
  }
  // 只提示邮箱 
  function threeHundredVoucherPackagePostErrorsEmail(errorMessage) {
    $('.three-hundred-voucher-package .error-email').text(errorMessage);
    $('.three-hundred-voucher-package .error-email').show();
    $('.three-hundred-voucher-package-con .row2 .before-i').css('display','block');
    $('.three-hundred-voucher-package-con .row2 .round-input-email').css('border','1.5px red solid');
    setTimeout(() => {
      
      $('.three-hundred-voucher-package .error-email').hide();
      $('.three-hundred-voucher-package-con .row2 .before-i').css('display','none');
      $('.three-hundred-voucher-package-con .row2 .round-input-email').css('border','1.5px #D1D5D9 solid');
    }, 10000);
  }

  // 只提示电话号
  function threeHundredVoucherPackagePostErrorsPhone(errorMessage) {
    $('.three-hundred-voucher-package .error-phone-number').text(errorMessage);
      $('.three-hundred-voucher-package .error-phone-number').show();
      $('.three-hundred-voucher-package-con .row2 .round-number-input .before-i').css('display','block');
      $('.three-hundred-voucher-package-con .row2 .round-number-input').css('border','1.5px red solid');

    setTimeout(() => {
      $('.three-hundred-voucher-package .error-phone-number').hide();
      $('.three-hundred-voucher-package-con .row2 .round-number-input .before-i').css('display','none');
      $('.three-hundred-voucher-package-con .row2 .round-number-input').css('border','1.5px #D1D5D9 solid');
      
    }, 10000);

  }


// 从浏览器存储中拿出86秒的数据
// function wheelPoupopDownTime() {
  
// }

  // 执行转盘自动显示
  // 先判断 star_pop_seconds: '5' 数据， 
  // 如果 star_pop_seconds 符合条件，执行 pop_seconds弹窗倒计时，到时间执行转盘弹窗
  function wheelPoupopBlock() {
    $('.sunber-wheel-poupop-con').css('display','block');
  }
  function wheelPoupopNone() {
    $('.sunber-wheel-poupop-con').css('display','none');
    console.log('show执行了侧边显示693');
    $('.sunber-wheel-poupop-con-sidebar').css('display','block');
  }
  // 执行300券包显示
  // threeHundredVoucherPackage();
  function threeHundredVoucherPackage() {

    $('.three-hundred-voucher-package-con').css('display','block');
    wheelPopupNumber(".three-hundred-voucher-package-con .round-number-input");
    threeVoucherPackageClickEvent();
    // 后续300券包接口出来之后，关闭300券包，调用
    // $('.all-voucher-package-con').css('display','block');
  }
  // 300券包执行邮箱注册和请求
  // $('.voucher-package-email-click-register ').on('click',function () {
  //   console.log("触发300券包邮箱注册请求");
  //   $('.three-hundred-voucher-package .round-input-email').val(''); 
  //   $('.three-hundred-voucher-package .phone-number-input').val('');
  // });
  // =-=-==-=-==-=-=-=-=-=-==-2=-==-=-==-=-==-=-==-=-==-=-==-=-==-=-==-=-==-

    // 侧边盒子
    sliderWheelGetItCheckout();
    // 检测侧边盒子
function threeVoucherPackageClickEvent() {
  
  // 718
  $('.voucher-package-email-click-register').on('click', function () {
    console.log("触发300券包邮箱注册请求");
    
    // 取值
    const emailVal = $('.three-hundred-voucher-package .round-input-email').val().trim();
    const phoneCodeVal = $('.three-hundred-voucher-package .phone-input .code').text().trim();
    const phoneVal = $('.three-hundred-voucher-package .phone-number-input').val().trim();
  
    // 邮箱正则校验
    const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // 简单国际手机号正则
    const phoneReg = /^\+?[1-9]\d{6,14}$/;
  
    let isValid = true; // 标记是否通过校验
  
    // 校验邮箱
    if (!emailVal || !emailReg.test(emailVal)) {
      isValid = false;
      console.log("邮箱不正确");
      $('.three-hundred-voucher-package .error-email').text('Please enter a valid email ');
      $('.three-hundred-voucher-package .error-email').show();
      $('.three-hundred-voucher-package-con .row2 .before-i').css('display','block');
      $('.three-hundred-voucher-package-con .row2 .round-input-email').css('border','1.5px red solid');
      setTimeout(() => {
        $('.three-hundred-voucher-package .error-email').hide();
        $('.three-hundred-voucher-package-con .row2 .before-i').css('display','none');
        $('.three-hundred-voucher-package-con .row2 .round-input-email').css('border','1.5px #D1D5D9 solid');
      }, 10000);
    }
  
    // 校验手机号
    // 校验手机号（允许为空）
  if (phoneVal) {
    if (!phoneReg.test(phoneVal)) {
      isValid = false;
      console.log("手机号不正确");
      $('.three-hundred-voucher-package .error-phone-number').text('Please enter a valid iphone');
      $('.three-hundred-voucher-package .error-phone-number').show();
      $('.three-hundred-voucher-package-con .row2 .round-number-input .before-i').css('display','block');
      $('.three-hundred-voucher-package-con .row2 .round-number-input').css('border','1.5px red solid');
      setTimeout(() => {
        $('.three-hundred-voucher-package .error-phone-number').hide();
        $('.three-hundred-voucher-package-con .row2 .round-number-input .before-i').css('display','none');
        $('.three-hundred-voucher-package-con .row2 .round-number-input').css('border','1.5px #D1D5D9 solid');
      }, 10000);
    }
  }

  
    // 如果都通过校验，才发起请求
    const email = emailVal;
    const phone = phoneCodeVal + phoneVal;
    if (isValid) {
      
      console.log("✅ 校验通过，执行邮箱注册请求 邮箱:", emailVal, "手机号:", phoneCodeVal, ":", phoneVal);
      $('.voucher-package-email-click-register').css("background" ,"#D5D7DA");
      $('.voucher-package-email-click-register .but-text').addClass('but-text-none');
      $('.voucher-package-email-click-register .spinner').addClass('load-spinner');
      // TODO: 发起 GET/POST 请求
      // threeHundredVoucherPackagePost(email,phone);


      // 提交时只带 email，如果 phone 不为空再带 phone
        if (phoneVal) {
          threeHundredVoucherPackagePost(email, phone);
          GAThreePopClickOpen();
        } else {
          threeHundredVoucherPackagePost(email);
          GAThreePopClickOpen();
        }
      
    }
  });
  
  // 300券包点击提交成功触发埋点
  function GAThreePopClickOpen () {
   const butTxt =  $(".three-hundred-voucher-package-con .row2 .voucher-package-email-click-register").text().trim();
   console.log(butTxt,"300提交按钮文案");
   
                const e_name = 'popUp'
                var path = window.location.pathname; 
                console.log('path:',path);
                console.log('cleanPath',path);
                
                console.log(path);
                const e_categroy = '$'+ path;
                const e_action = 'popUp_Click';
                const e_label = 'popUp::NewUser_'+path+butTxt;
                const e_remarks = 'autoPop'
                console.log('1:',e_name,'2',e_categroy,'3',e_action,'4',e_label,'5',e_remarks);
    
                // 调用 datalayer 方法  
                window.datalayer_popup_even_c({
                  event_name: e_name,
                  event_category: e_categroy,
                  event_action: e_action,
                  event_label: e_label,
                  event_remarks: e_remarks
                });    
  }

  // 300券包输入框获取焦点
  $('.three-hundred-voucher-package-con .row2 .round-input-email').on('input', function() {
    const emailVal = $(this).val(); // 获取当前输入值
    if (emailVal) {
        console.log('输入框有内容:', emailVal);
        $('.three-hundred-voucher-package-con .row2 .after-i').css('display','block');
    } else {
      $('.three-hundred-voucher-package-con .row2 .after-i').css('display','none');
    }
});

  // 300券包邮箱清空
  $('.three-hundred-voucher-package-con .row2 .after-i .icon-x-close1').on('click',function () {
    $('.three-hundred-voucher-package-con .row2 .round-input-email').val(''); // 清空输入框内容
    $(this).closest('.after-i').css('display','none'); // 隐藏清空图标
  });
  
  // 关闭300券包,弹出优惠券773
  $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').on('click',function () {
  // $(document).on('click', '.three-hundred-voucher-package-con .wheel-spin-box-close-x', function () {
    console.log("关闭300券包，弹出优惠券1111");
    // $('.all-voucher-package-enter-slider').css('display','block')
    // $('.three-hundred-voucher-package-con').css('display','none');
    // 点击关闭，触发埋点
        const ec_name = 'popUp'
        var path_c = window.location.pathname; 
        console.log('path:',path_c);
        console.log('cleanPath',path_c);

        console.log(path_c);
        const ec_categroy = '$'+ path_c;
        const ec_action = 'popUp_Click';
        const ec_label = 'popUp::TurnTable_'+path_c+'::Close';
        const ec_remarks = 'clickPop'
        console.log('1:',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label,'5',ec_remarks);

        // 调用 datalayer 方法
        window.datalayer_popup_even_c({
          event_name: ec_name,
          event_category: ec_categroy,
          event_action: ec_action,
          event_label: ec_label,
          event_remarks: ec_remarks
        });
    const StayContainerCon = sessionStorage.getItem("threeHundredVoucherPackageStayContainerCon");
    console.log(StayContainerCon,'挽留弹窗标识');
    
    if (StayContainerCon) {
      $('.three-hundred-voucher-package-con').css('display','none');
      $('.all-voucher-package-enter-slider').css('display','block')
    }else{
      $('.three-hundred-voucher-package-con .stay-container-con').css('display','block');
      $('.three-hundred-voucher-package-con .container-con').css('display','none');
      $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','none');
    }
    
  });

  // 挽留弹窗选择
  $('.three-hundred-voucher-package-con .stay-container-con .bot-left').on('click',function () {
    console.log('挽留左边点击存储[threeHundredVoucherPackageStayContainerCon] + [threeHundredVoucherPackageGetIt]');
    
    $('.three-hundred-voucher-package-con ').css('display','none');
    sessionStorage.setItem("threeHundredVoucherPackageStayContainerCon", "true");
    sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
    $('.all-voucher-package-enter-slider').css('display','block')
    sessionStorage.setItem("sunberWheelPoupopConSidebarClose", "true");

  });
  $('.three-hundred-voucher-package-con .stay-container-con .bot-right').on('click',function () {
    console.log('挽留右边点击存储[threeHundredVoucherPackageStayContainerCon] + [threeHundredVoucherPackageGetIt]');
    sessionStorage.setItem("threeHundredVoucherPackageStayContainerCon", "true");
    sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
    $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','block');
    $('.three-hundred-voucher-package-con .container-con').css('display','block');
    $('.three-hundred-voucher-package-con .stay-container-con').css('display','none');
    sessionStorage.setItem("sunberWheelPoupopConSidebarClose", "true");
  });
  // 全部优惠券
    // 复制优惠券折扣码
    $('.all-voucher-package-con .coupon-con').on('click', '.li-coupon .icon-info', function() {
      console.log("复制优惠券折扣码触发");
    
      // 获取优惠券码
      const coText = $(this)
        .closest('.li-coupon')
        .find('.right-in .p-bot .code')
        .text()
        .trim();
    
      console.log("触发复制优惠券折扣码:", coText);
       //复制成功弹出  
          // $(' .all-voucher-package-con .row1 .success-alter').addClass('success-alter-pos')
          var $row = $(this).closest('.all-voucher-package-con .row1');
          var $success = $row.find('.coupon-con .coupon .success-alterr')
          $success.addClass('success-alter-pos');
          setTimeout(function () {
            $success.removeClass('success-alter-pos');
          }, 3000);
    
      if (coText) {
        
        // 复制到剪切板
        navigator.clipboard.writeText(coText)
          .then(() => {
            console.log("✅ 已复制到剪切板:", coText);
            // alert("优惠券已复制：" + coText); // 可改成 toast 提示
          })
          .catch(err => {
            console.error("❌ 复制失败:", err);
          });
        
      } else {
        console.log("⚠️ 未获取到优惠券码");
      }
    });
    // 点击优惠券按钮
    $('.all-voucher-package-con .container-con .row2-but .but-a-text').on('click', function (e) {
      e.preventDefault(); // 阻止默认跳转
      // const voucherPackagePostSuccess = sessionStorage.getItem("threeHundredVoucherPackagePostSuccess");
      const voucherPackageLoginUrl = sessionStorage.getItem("threeHundredVoucherPackagePostSuccessLogin");
      console.log("拿出登录链接", voucherPackageLoginUrl);
  
      if (voucherPackageLoginUrl) {
            // 添加券包登录成功标识
            sessionStorage.setItem("allVoucherPackageLoginSuccess", "true");
          // 跳转到存的登录链接
          window.location.href = voucherPackageLoginUrl;
      } else {
          // 没有存链接，就按照原来的 href 跳转
          const originalHref = $(this).attr('href');
          window.location.href = originalHref;
      }
    });
  
    // 关闭优惠券 的 挽留弹窗
    $('.all-voucher-package-con .wheel-spin-box-close-x').on('click',function () {
      console.log("关闭优惠券，弹出挽留");
      // $('.all-voucher-package-con .wheel-spin-box-close-x').css('display','none');
      $('.all-voucher-package-con ').css('display','none');
      $('.all-voucher-package-enter-slider').css('display','block')
      // $('.all-voucher-package-con .stay-container-con').css('display','block');
      
    });
    //优惠券弹窗入口

    $('.all-voucher-package-enter-slider .coupon-enter-slider-btn ').on('click',function () {
      console.log("触发优惠券弹窗入口3");
      

      const voucherPackagePostSuccess = sessionStorage.getItem("threeHundredVoucherPackagePostSuccess");
      const postSuccess = sessionStorage.getItem("wheelPoupopPostSuccess");
      const userEmail = window.customerData.email ;
      if (userEmail) {
        $('.all-voucher-package-con').css('display','block');
      } else {
        if (voucherPackagePostSuccess || postSuccess) {
          $('.all-voucher-package-con').css('display','block');
           
        } else {
          $('.three-hundred-voucher-package-con').css('display','block');
          $('.three-hundred-voucher-package-con .stay-container-con').css('display','none');
          $('.three-hundred-voucher-package-con .container-con ').css('display','block');
          $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','block');
          
        }
        
      }
      
    });
    // 300券包入口
    $('.all-voucher-package-enter-slider .sunber-wheel-poupop-con-sidebar-close .iconfont ').on('click',function () {
      console.log("关闭1");
      
      $('.all-voucher-package-enter-slider').css('display','none');
      sessionStorage.setItem("threeHundredVoucherPackageGetItClose", "true");
    });
  // 全部优惠券
}
// function AllVoucherPackageConClickEvent() {
  
// }
  // 关闭300券包,弹出优惠券773
  $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').on('click',function () {
    // $(document).on('click', '.three-hundred-voucher-package-con .wheel-spin-box-close-x', function () {
      console.log("关闭300券包，弹出优惠券1111");
      // $('.all-voucher-package-enter-slider').css('display','block')
      // $('.three-hundred-voucher-package-con').css('display','none');
      // 点击关闭，触发埋点
          const ec_name = 'popUp'
          var path_c = window.location.pathname; 
          console.log('path:',path_c);
          console.log('cleanPath',path_c);
  
          console.log(path_c);
          const ec_categroy = '$'+ path_c;
          const ec_action = 'popUp_Click';
          const ec_label = 'popUp::TurnTable_'+path_c+'::Close';
          const ec_remarks = 'clickPop'
          console.log('1:',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label,'5',ec_remarks);
  
          // 调用 datalayer 方法
          window.datalayer_popup_even_c({
            event_name: ec_name,
            event_category: ec_categroy,
            event_action: ec_action,
            event_label: ec_label,
            event_remarks: ec_remarks
          });
      const StayContainerCon = sessionStorage.getItem("threeHundredVoucherPackageStayContainerCon");
      console.log(StayContainerCon,'挽留弹窗标识');
      
      if (StayContainerCon) {
        $('.three-hundred-voucher-package-con').css('display','none');
        $('.all-voucher-package-enter-slider').css('display','block')
      }else{
        $('.three-hundred-voucher-package-con .stay-container-con').css('display','block');
        $('.three-hundred-voucher-package-con .container-con').css('display','none');
        $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','none');
      }
      
    });
  
    // 挽留弹窗选择
    // $('.three-hundred-voucher-package-con .stay-container-con .bot-left').on('click',function () {
    //   console.log('挽留左边点击存储[threeHundredVoucherPackageStayContainerCon] + [threeHundredVoucherPackageGetIt]');
      
    //   $('.three-hundred-voucher-package-con ').css('display','none');
    //   sessionStorage.setItem("threeHundredVoucherPackageStayContainerCon", "true");
    //   sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
    //   $('.all-voucher-package-enter-slider').css('display','block')
  
    // });
    // $('.three-hundred-voucher-package-con .stay-container-con .bot-right').on('click',function () {
    //   console.log('挽留右边点击存储[threeHundredVoucherPackageStayContainerCon] + [threeHundredVoucherPackageGetIt]');
    //   sessionStorage.setItem("threeHundredVoucherPackageStayContainerCon", "true");
    //   sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
    //   $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','block');
    //   $('.three-hundred-voucher-package-con .container-con').css('display','block');
    //   $('.three-hundred-voucher-package-con .stay-container-con').css('display','none');
    // });
  // 复制优惠券折扣码
  $('.all-voucher-package-con .coupon-con').on('click', '.li-coupon .icon-info', function() {
    console.log("复制优惠券折扣码触发");
  
    // 获取优惠券码
    const coText = $(this)
      .closest('.li-coupon')
      .find('.right-in .p-bot .code')
      .text()
      .trim();
  
    console.log("触发复制优惠券折扣码:", coText);
     //复制成功弹出  
        // $(' .all-voucher-package-con .row1 .success-alter').addClass('success-alter-pos')
        var $row = $(this).closest('.all-voucher-package-con .row1');
        var $success = $row.find('.coupon-con .coupon .success-alterr')
        $success.addClass('success-alter-pos');
        setTimeout(function () {
          $success.removeClass('success-alter-pos');
        }, 3000);
  
    if (coText) {
      
      // 复制到剪切板
      navigator.clipboard.writeText(coText)
        .then(() => {
          console.log("✅ 已复制到剪切板:", coText);
          // alert("优惠券已复制：" + coText); // 可改成 toast 提示
        })
        .catch(err => {
          console.error("❌ 复制失败:", err);
        });
      
    } else {
      console.log("⚠️ 未获取到优惠券码");
    }
  });
  // 点击优惠券按钮
  $('.all-voucher-package-con .container-con .row2-but .but-a-text').on('click', function (e) {
    e.preventDefault(); // 阻止默认跳转
    // const voucherPackagePostSuccess = sessionStorage.getItem("threeHundredVoucherPackagePostSuccess");
    const voucherPackageLoginUrl = sessionStorage.getItem("threeHundredVoucherPackagePostSuccessLogin");
    console.log("拿出登录链接", voucherPackageLoginUrl);

    if (voucherPackageLoginUrl) {
          // 添加券包登录成功标识
          sessionStorage.setItem("allVoucherPackageLoginSuccess", "true");
        // 跳转到存的登录链接
        window.location.href = voucherPackageLoginUrl;
    } else {
        // 没有存链接，就按照原来的 href 跳转
        const originalHref = $(this).attr('href');
        window.location.href = originalHref;
    }
  });

  // 关闭优惠券 的 挽留弹窗
  $('.all-voucher-package-con .wheel-spin-box-close-x').on('click',function () {
    console.log("关闭优惠券，弹出挽留");
    // $('.all-voucher-package-con .wheel-spin-box-close-x').css('display','none');
    $('.all-voucher-package-con ').css('display','none');
    // $('.all-voucher-package-con .stay-container-con').css('display','block');
    
  });
  //优惠券弹窗入口
  $('.all-voucher-package-enter-slider .coupon-enter-slider-btn ').on('click',function () {
    console.log("触发优惠券弹窗入口6");
    threeVoucherPackageClickEvent();
    const voucherPackagePostSuccess = sessionStorage.getItem("threeHundredVoucherPackagePostSuccess");
    const postSuccess = sessionStorage.getItem("wheelPoupopPostSuccess");
    const userEmail = window.customerData.email ;
    if (userEmail) {
      $('.all-voucher-package-con').css('display','block');
    } else {
      if (voucherPackagePostSuccess || postSuccess) {
        $('.all-voucher-package-con').css('display','block');
         
      } else {
        $('.three-hundred-voucher-package-con').css('display','block');
        $('.three-hundred-voucher-package-con .stay-container-con').css('display','none');
        $('.three-hundred-voucher-package-con .container-con ').css('display','block');
        $('.three-hundred-voucher-package-con .wheel-spin-box-close-x').css('display','block');
        
      }
      
    }
    
  });
  // 300券包入口
  $('.all-voucher-package-enter-slider .sunber-wheel-poupop-con-sidebar-close .iconfont ').on('click',function () {
    console.log("关闭1");
    
    $('.all-voucher-package-enter-slider').css('display','none');
    sessionStorage.setItem("threeHundredVoucherPackageGetItClose", "true");
  });

  //   转盘接口请求
    function postDailyData() {
      // if (!shouldSendRequestNY()) return;
      console.log("执行postDailyData方法");

      // 把数据从会话窗口中拿出
      let res = sessionStorage.getItem("popuManageResponse");
      if (res) {
          let obj = JSON.parse(res); // 转回对象
        console.log("📦 存储的数据为：", obj.data);
      }else{
          console.log('data打印',res);

      }
      let obj = JSON.parse(res);
      // const waitingTime =obj.length[0].content.pop_seconds
      const activity_id = obj.data[0].content.reward_activity_id
      const pop_seconds = obj.data[0].content.pop_seconds
      const urlObj = obj.data[0].show_page_url
      console.log("打印会话存储的id✅",activity_id);
      console.log("打印会话存储的时间✅",pop_seconds);
      urlAutoWheelPoupopFun(urlObj)
      urlObj.forEach((item) => {
        console.log('打印过来的链接地址',item)

      });

      // 延迟执行弹窗逻辑
      // setTimeout(()=>{
      //   wheelPoupopBlock()
      // },5000)

      let wheelTimerId = null; // 保存当前定时器 ID
      let lastTargetTime = null; // 防止重复执行

      // 启动倒计时 1024
      function startWheelTimer(delayMs) {
        console.log("调用倒计时方法1026");
        const targetTime = Date.now() + delayMs; // 计算目标时间戳
        localStorage.setItem("wheelTargetTime", targetTime); // 存到 localStorage
        runTimer(targetTime); // 开始计时
      }

      // 安排转盘 根据后台倒计时时间 执行
      function runTimer(targetTime) {
        console.log('开始倒计时1034');
        // 避免重复安排同一个目标时间
        if (targetTime === lastTargetTime);
        lastTargetTime = targetTime;
      
        // 清理已有定时器
        if (wheelTimerId) {
          clearTimeout(wheelTimerId);
          wheelTimerId = null;
        }
      
        const remaining = targetTime - Date.now();
      
        if (remaining <= 0) {
          console.log('倒计时小于0');
          executeWheelPopup();
          localStorage.removeItem("wheelTargetTime");
        } else {
          console.log('倒计时不小于0');
          

          // 打印倒计时（每秒刷新一次）

          wheelTimerId = setTimeout(() => {
            executeWheelPopup();
            localStorage.removeItem("wheelTargetTime");
            wheelTimerId = null;
          }, remaining);
        }
      }

      // 弹窗逻辑 被定时器调用
      function executeWheelPopup() {
        console.log("执行转盘弹窗逻辑 自动执行弹出1");
        
        // 这里写实际弹窗代码，比如 openWheelPopup();定时器调用真是的弹窗盒子
        // 执行之前先判断是否有券包300弹窗，有的话，就先不弹这个转盘，点击完300关闭再弹转盘
        const userEmail = window.customerData?.email;
        if (userEmail) {
          console.log("用户已登录，不执行转盘弹窗");
        
        }else{
          console.log("用户未登录，执行转盘弹窗");


          // / 把数据从会话窗口中拿出
          let res = sessionStorage.getItem("popuManageResponse");
          if (res) {
              let obj = JSON.parse(res); // 转回对象
              // console.log("📦 存储的数据为：", obj.data);
          }
          let obj = JSON.parse(res);
          // const waitingTime =obj.length[0].content.pop_seconds
          const wheelStatus = obj.data[0].status
          const threeStatus = obj.data[1].status
          console.log('转盘和券包的开关状态1020',wheelStatus,threeStatus);
      
          if (wheelStatus == '1') {
            console.log("转盘打开后台开关");
            // 侧边盒子
            sliderWheelGetItCheckout();
            wheelPoupopBlock() // 关闭弹窗展示盒子8.16
            // 👉 自动弹窗触发事件
           // 自动弹窗触发时调用
           if ($('.sunber-wheel-poupop-con').css('display') === 'block') {
            console.log("存在：弹窗已经显示");
            // 打开转盘埋点
            const e_name = 'popUp'
            var path = window.location.pathname; 
            console.log('path:',path);
            console.log('cleanPath',path);
            
            console.log(path);
            const e_categroy = '$'+ path;
            const e_action = 'popUp';
            const e_label = 'popUp::TurnTable_'+path+'::view';
            const e_remarks = 'autoPop'
            console.log('1:',e_name,'2',e_categroy,'3',e_action,'4',e_label,'5',e_remarks);

            // 调用 datalayer 方法
            window.datalayer_popup_even_n({
              event_name: e_name,
              event_category: e_categroy,
              event_action: e_action,
              event_label: e_label,
              event_remarks: e_remarks
            });
            
  
          }
            
          }
        

        }
      }

      // 页面加载时恢复倒计时
      window.addEventListener("load", () => {
        const savedTarget = localStorage.getItem("wheelTargetTime");
        if (savedTarget) {
          runTimer(parseInt(savedTarget, 10));
        }
      });

      // 跨标签页同步倒计时（可选）
      window.addEventListener("storage", (e) => {
        if (e.key === "wheelTargetTime" && e.newValue) {
          runTimer(parseInt(e.newValue, 10));
        }
      });

// =--=-=-=-=-=-=-=-=-=-=-=-=-3=-=-=-=-=-=-=-=--=-=-=-=

  function urlAutoWheelPoupopFun(urlObj) {
    const path = window.location.pathname;  
    console.log("当前路径:", path);
  
    // 只要有一个 item 被包含在 path 中就算匹配
    const matched = urlObj.some(item => path.includes(item));
  
    if (matched) {
      console.log("✅ 匹配成功，隐藏弹窗");
      $('.all-wheel-poupop-voucher-package-alter').css('display', 'none');
    } else {
      console.log("❌ 没有匹配，保持显示");
      $('.all-wheel-poupop-voucher-package-alter').css('display', 'block');
    }
  }
  let scrollTimer = null;

  $(window).on('scroll', function () {
    // 只在手机端执行
    if ($(window).width() < 768) {
      const $container = $('.all-voucher-package-enter-slider');
  
      if ($container.css('display') !== 'none') {
        // 滚动时先隐藏
        $container.hide();
  
        // 清除之前的定时器
        clearTimeout(scrollTimer);
  
        // 停止滚动 300ms 后再显示
        scrollTimer = setTimeout(() => {
          $container.show();
        }, 300);
      }
    }
  });
  
  




autoWheelPoupopFun();

function autoWheelPoupopFun() {
    console.log("执行自动转盘弹窗方法");

    // 从会话存储获取后端数据
    let sessionStorageRes = sessionStorage.getItem("popuManageResponse");
    if (!sessionStorageRes) {
        console.log('没有存储的数据，退出方法');
        return;
        return;
    }

    let sessionStorageObj = JSON.parse(sessionStorageRes);
    const activity_id = sessionStorageObj.data[0].content.reward_activity_id;
    const star_pop_seconds = sessionStorageObj.data[0].content.star_pop_seconds; // 倒计时总秒数
    const pop_seconds = sessionStorageObj.data[0].content.pop_seconds; // 弹窗渲染时间（秒）
    const renderingTime = pop_seconds * 1000; // 转换为毫秒

    console.log("打印会话存储的id✅✅", activity_id);
    console.log("打印 star_pop_seconds ✅✅单位：秒", star_pop_seconds);
    console.log("打印 pop_seconds ✅✅单位：天", pop_seconds);

    const storageKey = `autoWheelPop_${activity_id}`;
    const now = Date.now(); // 当前时间戳（毫秒）
    let endTime = localStorage.getItem(storageKey);

    if (!endTime) {
        // 首次访问，立即触发弹窗
        console.log("首次访问，立即触发弹窗");
        startWheelTimer(renderingTime);
        // 设置倒计时结束时间
        localStorage.setItem(storageKey, now + star_pop_seconds * 1000);
        console.log(`首次设置倒计时结束时间：${star_pop_seconds} 秒后(单位:秒)`);

        let remaining = star_pop_seconds;
        console.log(`转盘首次开始倒计时：${remaining} 秒`);

        const intervalId = setInterval(() => {
          remaining--;
          if (remaining <= 0) {
            clearInterval(intervalId);
            console.log("转盘首次倒计时结束");
            executeWheelPopup(); // 触发一次
          } else {
            console.log(`转盘首次倒计时中...剩余 ${remaining} 秒`);
          }
        }, 1000);


    }

    endTime = parseInt(endTime);
    console.log("转盘打印测试时间：now",now);
    console.log("转盘打印结束时间endTime",endTime)
    
    if (now < endTime) {
        // 倒计时未结束，计算剩余时间
        let remaining = endTime - now;
        console.log(`倒计时未结束，还剩 ${Math.ceil(remaining / 1000)} 秒`);

        // 每秒打印剩余时间，并在结束时触发弹窗
        const interval = setInterval(() => {
            const nowCheck = Date.now();
            const remainSec = Math.ceil((endTime - nowCheck) / 1000);

            if (remainSec <= 0) {
                clearInterval(interval);
                console.log("倒计时结束，触发弹窗");
                startWheelTimer(renderingTime);
                // 更新新的倒计时结束时间
                localStorage.setItem(storageKey, Date.now() + star_pop_seconds * 1000);
                console.log(`新的倒计时开始：${star_pop_seconds} 秒`);
            } else {
                console.log(`倒计时中...剩余 ${remainSec} 秒(单位:天)`);
            }
        }, 1000);
    } else {
        // 倒计时已结束，立即触发弹窗并重置倒计时
        console.log("倒计时结束，立即触发弹窗");
        let res = sessionStorage.getItem("popuManageResponse");
        if (res) {
            let obj = JSON.parse(res); // 转回对象
            // console.log("📦 存储的数据为：", obj.data);
        }
        let obj = JSON.parse(res);
        // const waitingTime =obj.length[0].content.pop_seconds
        const wheelStatus = obj.data[0].status
        const threeStatus = obj.data[1].status
        console.log('转盘和券包的开关状态1194',wheelStatus,threeStatus);
    
        if (wheelStatus == '1') {
          const wheelPoupopConSidebarClose = sessionStorage.getItem("sunberWheelPoupopConSidebarClose");
          const voucherPackageGetIt = sessionStorage.getItem("threeHundredVoucherPackageGetIt");
          console.log('执行了侧边显示1258',wheelPoupopConSidebarClose);
          if (!wheelPoupopConSidebarClose && !voucherPackageGetIt) {
            $('.sunber-wheel-poupop-con-sidebar').css('display','block');
          }
        startWheelTimer(renderingTime);
        localStorage.setItem(storageKey, now + star_pop_seconds * 1000);
        console.log(`转盘倒计时结束后重新设置：${star_pop_seconds} 秒注释：执行了天之后执行这个时间在立即打开 `);
        }
    }
}




      

    //侧标边栏打开弹窗

// 打开逻辑
$('.sunber-wheel-poupop-con-sidebar').on('click', function () {
  // 点击侧边的时候得执行一下换坐标图片
  console.log("触发侧边转盘弹窗展示 主动执行弹出1");
  sessionStorage.setItem("ClickWheelPoupop", "true");
  // 获取转盘是否成功注册抽奖
  const wheelPostSuccess = sessionStorage.getItem("wheelPoupopPostSuccess");
  if (wheelPostSuccess) {
    $('.sunber-wheel-poupop-con .wheel-spin-box .wheel-spin-arrow img').attr('src', 'https://cdn.shopify.com/s/files/1/1720/3969/files/Frame_2085663251.png?v=1756170860');
  }
  const userEmail = window.customerData?.email; // 检测是否登录
  // 先判断是否转盘进行过抽奖
  const prizeStr = sessionStorage.getItem("popuManageResponseMatchedPrize");
  const prizeObj = prizeStr ? JSON.parse(prizeStr) : null;
      
    console.log("中奖对象:", prizeObj);
    console.log("标题:", prizeObj?.title);
    console.log("副标题:", prizeObj?.sub_title);
    console.log("优惠码:", prizeObj?.coupons?.code);

  function GAslideWheelPopClickOpen() {
    // 点击抽奖成功，触发埋点
    const ec_name = 'sideBar'
    var path_c = window.location.pathname; 
    console.log('path:',path_c);
    console.log('cleanPath',path_c);
    
    console.log(path_c);
    const ec_categroy = '$'+ path_c;
    const ec_action = 'click';
    const ec_label = 'btn::TurnTable';
    const ec_remarks = 'clickPop'
    console.log('1:',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label);

    // 调用 datalayer 方法
    window.datalayer_popup_even_n({
      event_name: ec_name,
      event_category: ec_categroy,
      event_action: ec_action,
      event_label: ec_label
    });
  }


  if (prizeObj) {
    // 用户已中奖
    console.log("用户已中奖，打开已中奖弹窗");
    // 显示中奖弹窗
    $('.sunber-wheel-poupop-con').show();

    const $wheelPoupopRoundCon = $('.sunber-wheel-poupop-con ')
        $wheelPoupopRoundCon.find('.wheel-round-image').css('display','none');
        $wheelPoupopRoundCon.find('.wheel-poupop-position-round').css('display','none');
        $wheelPoupopRoundCon.find(' .wheel-awards-poupop').addClass('wheel-awards-poupop-furnish');

    GAslideWheelPopClickOpen()
    // 渲染奖品内容
    furnishHtmlCon(prizeObj);
  
  } else {
    // 用户未中奖，才判断是否登录
    console.log("用户未通过转盘已中奖，打开券列表弹窗");
  
    if (userEmail) {
      // 已登录
      console.log("用户已登录，直接打开转盘弹窗");
      $('.all-voucher-package-con').show();
    } else {
      // 未登录
      $('.sunber-wheel-poupop-con').show();
      GAslideWheelPopClickOpen()

    }
  }
  
  




});

// 关闭逻辑
$('.sunber-wheel-poupop-con-sidebar .sunber-wheel-poupop-con-sidebar-close').on('click', function (e) {
  e.stopPropagation(); // 阻止事件冒泡
  console.log('关闭侧边转盘入口');
  // 存一个事件关闭了就不展示了
  sessionStorage.setItem("sunberWheelPoupopConSidebarClose", "true");
  $('.sunber-wheel-poupop-con-sidebar').css('display', 'none');//关闭侧边转盘入口 
});



      // 🔽 请求奖品列表接口
      $.ajax({
        "url": "http://plugin.kriyya.com/api/sunber/reward/lists",
        "method": "GET",
        "timeout": 0,
        "headers": {
          "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5",

        },
        "data": { 
          activity_id: activity_id
        },
        success: function (res) {
          console.log('✅打印转盘奖品列表返回的数据',res);
          // 调用转盘渲染方法
          wheelPopupRendering(res);
           // 1️⃣ 存入 sessionStorage，必须转换成字符串
          sessionStorage.setItem('popuManageResponseList', JSON.stringify(res));

        },
        error: function (xhr, status, err) {
          console.error("❌ 请求失败：", xhr.status, err);
        }
      });
    }
    // 触发复制 
    function poupopFurnishSecces() {
      console.log("执行复制功能");
      
      $('.wheel-awards-poupop-furnish .row3 .iconfont').on('click', function () {
        const text = $('.wheel-awards-poupop-furnish .row3 .text').text().trim();
        console.log("触发复制",$('.wheel-awards-poupop-furnish .copy-success').length);
        // .copy-success-block
        $('.wheel-awards-poupop-furnish .copy-success').addClass('copy-success-block');

        setTimeout(function () {
          $('.wheel-awards-poupop-furnish .copy-success').removeClass('copy-success-block');
        }, 3000);

        if (text) {
            navigator.clipboard.writeText(text).then(() => {
                // alert('已复制: ' + text);
            });
        }
      });
    }

    // 运行    
   
    // 抽奖信息 盒子渲染
    function lotteryInformation(obj2) {
      console.log("执行信息奖项盒子");
      const $wheelPoupopRoundCon = $('.sunber-wheel-poupop-con ')
      
      if ($wheelPoupopRoundCon) {
          $wheelPoupopRoundCon.find('.wheel-round-image').css('display','none');
          $wheelPoupopRoundCon.find('.wheel-poupop-position-round').css('display','none');
          $wheelPoupopRoundCon.find(' .wheel-awards-poupop').addClass('wheel-awards-poupop-furnish');
          let res3 = sessionStorage.getItem("popuManageResponseList");
          console.log("1631中奖信息获取",res3);
          if (obj2) {
            console.log('1636打印转盘中奖信息',obj2);
            
          }

          
            if (obj2) {
              let obj = JSON.parse(res3); // 转回对象
              const prizeList = obj.data; // 奖品列表数组
              const lotteryId = obj2.data.id; // 接口返回中奖id
              console.log('打印转盘中奖遍历列表信息',obj);
              
              console.log("转盘中奖的ID",lotteryId);
            
              // 找到匹配的奖品
              const matchedPrize = prizeList.find(item => item.id === lotteryId);

              const matchedPrizee = obj2.data
              console.log('打印转盘中奖信息matchedPrize-1',matchedPrize);
              console.log('打印转盘中奖信息matchedPrizee-2',matchedPrizee);
            
              if (matchedPrizee) {
                // 进行倒计时计算，到时间关闭侧边转盘悬浮
               
                
                // 获取依次推送
                  console.log("🎯 匹配的奖品数据1:", matchedPrizee);
                  // 存储中奖信息
                  // console.log("需要推送的数据title:",matchedPrize.title,"subtitle:",matchedPrize.subtitle);
                  sessionStorage.setItem("popuManageResponseMatchedPrize",JSON.stringify(matchedPrizee))
                  // ${obj2.login_url}
                  sessionStorage.setItem("popuManageResponseMatchedPrizeUrl",JSON.stringify(obj2.login_url))
                  // 动态生成 HTML 独立出来，进行调用
                  // ${matchedPrize.image || 'https://cdn.shopify.com/s/files/1/1720/3969/files/image_3301.png?v=1755306484'}
                  furnishHtmlCon(matchedPrizee);
                  setRegisterCountdown(5); // 存一个 5 分钟后的时间戳

                  // 点击抽奖成功，触发埋点
                  const wheelButText = $('.sunber-wheel-poupop-con .wheel-poupop-position-round .wheel-poupop-button').text()
                  const ec_name = 'popUp'
                  var path_c = window.location.pathname; 
                  console.log('path:',path_c);
                  console.log('cleanPath',path_c);

                  console.log(path_c);
                  const ec_categroy = '$'+ path_c;
                  const ec_action = 'popUp_Click';
                  const ec_label = 'popUp::TurnTable_'+path_c+wheelButText;
                  const ec_remarks = 'clickPop'
                  console.log('提交按钮(提交成功):',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label,'5',ec_remarks,'6',wheelButText);

                  // 调用 datalayer 方法
                  window.datalayer_popup_even_c({
                    event_name: ec_name,
                    event_category: ec_categroy,
                    event_action: ec_action,
                    event_label: ec_label,
                    event_remarks: ec_remarks
                  });
            
                  // 抽奖信息显示触发埋点
                  const e_name = 'popUp'
                  var path = window.location.pathname; 
                  console.log('path:',path);
                  console.log('cleanPath',path);
                  
                  console.log(path);
                  const e_categroy = '$'+ path;
                  const e_action = 'popUp';
                  const e_label = 'popUp::TurnTableRewards_'+path+'::view';
                  const e_remarks = 'autoPop'
                  console.log('1:',e_name,'2',e_categroy,'3',e_action,'4',e_label,'5',e_remarks);
      
                  // 调用 datalayer 方法
                  window.datalayer_popup_even_n({
                    event_name: e_name,
                    event_category: e_categroy,
                    event_action: e_action,
                    event_label: e_label,
                    event_remarks: e_remarks
                  });

                // 执行复制功能
                poupopFurnishSecces();

              } else {
                  console.log("⚠️ 未找到匹配的奖品");
              }
            
              // 打印 obj2 的 image 和 login_url 
              // 中奖图片链接和登录链接 后续推送
              console.log("🏞 image:", obj2.data.image);
              console.log("🔗 login_url:", obj2.login_url);
            
            } else {
              console.log('⚠️ sessionStorage 没有数据:', res3);
            }
        
      }else{
        console.log("没找到他yuannone");
        
      }
    }
     // 插入转盘中奖信息  
     function furnishHtmlCon(matchedPrize, obj2) {
      // ${matchedPrize.coupons.code || 'N/A'}
      let codeText = matchedPrize.coupons.code
      let codeTitleText = 'Your Discount Code Is:'
      let codeNone =''
      console.log("调用独立出来的插入奖品模块", matchedPrize,'1',matchedPrize.title,'2',matchedPrize.sub_title,'3',matchedPrize.coupons.code,'4',matchedPrize.type,'类型');
      if (matchedPrize.type == '2') {
        codeText = matchedPrize.gitf_card_code  || 'N/A'
        
      } else if (matchedPrize.type == '3') {
        codeNone = 'style="display:none;"'
        codeTitleText = 'Please check your account.'
      }
      
      const furnishHtml = `
      <div class="furnish-con">
        <div class="row1">
          <p class="p1">Congratulations</p>
        </div>
        <div class="row2">
          <i class="i-img">
            <img width="100%" height="auto" 
              class="lazyloaded" 
              src="https://cdn.shopify.com/s/files/1/1720/3969/files/image_3301.png?v=1755306484" 
              alt="">
          </i>
          <p class="p1">${matchedPrize.name}</p>
          <p class="p2">${matchedPrize.sub_title || ''}</p>
        </div>
        <div class="row3">
          <p class="p1">${codeTitleText} </p>
          <p class="p2" ${codeNone}>
            <span class="text">${codeText}   </span>
            <span class="iconfont icon-copy-06"></span>
            <span class="copy-success" style="display:none;">Copy Success!</span>
          </p>
        </div>
        <div class="row4">
          <a href="" target="_blank" class="a-but">Shop Now</a>
        </div>
      </div>
    `;

    // 插入到容器中
    $('.wheel-awards-poupop-furnish').html(furnishHtml);
    poupopFurnishSecces();
    wheelPoupopShopNowClick();
    }
  // 事件委托，父容器不变，子元素动态插入也能监听
// $('.sunber-wheel-poupop-con').on('click', '.furnish-con .row4 .a-but', function(e) {
//   e.preventDefault(); // 如果要阻止默认跳转
//   console.log("点击了跳转按钮 ✅", $(this).attr('href'));
  
//   // 这里可以做埋点、上报、跳转前逻辑等
// });
wheelPoupopShopNowClick();
function wheelPoupopShopNowClick () {
  $('.sunber-wheel-poupop-con').on('click', '.furnish-con .row4 .a-but', function(e) {
    e.preventDefault(); // 阻止 <a> 默认跳转
  
    // 从 sessionStorage 取出登录地址
    const urlStr = sessionStorage.getItem("popuManageResponseMatchedPrizeUrl");
    console.log('打印从控制台拿存储的登录链接urlStr',urlStr);
    
    const loginUrl = urlStr ? JSON.parse(urlStr) : null;
  
    if (loginUrl) {
      // 当前页跳转
      window.location.href = loginUrl;
      console.log('打印从控制台拿存储的登录链接loginUrl',loginUrl);
    }

    // if (loginUrl) {
    //   console.log('准备执行自动登录请求:', loginUrl);
    
    //   // 通过 fetch 执行 GET 登录请求
    //   fetch(loginUrl, {
    //     method: 'GET',
    //     credentials: 'include', // ✅ 关键！允许跨域携带 cookie
    //   })
    //     .then((res) => {
    //       console.log('登录请求完成', res.status);
    //       if (res.ok) {
    //         // ✅ 登录成功，延迟刷新页面
    //         setTimeout(() => {
    //           window.location.reload();
    //         }, 1000);
    //       } else {
    //         console.warn('登录请求未成功');
    //       }
    //     })
    //     .catch((err) => {
    //       console.error('登录请求失败:', err);
    //     });
    // }


  });
  
}



// 弹窗渲染方法
function wheelPopupRendering(resData) {
  var responseWheelPopupData = [];

  if (Array.isArray(resData)) {
    responseWheelPopupData = resData; // 直接赋值整个数组
  } else if (resData && resData.data) {
    responseWheelPopupData = resData.data; // 如果是对象，取 data 
  }

  console.log("📦 responseWheelPopupData 数组：", responseWheelPopupData);



  // 转盘弹窗js
  var wheelPopupPadding = {top:0, right:0, bottom:0, left:0},            w = 400 - wheelPopupPadding.left - wheelPopupPadding.right,            h = 400 - wheelPopupPadding.top  - wheelPopupPadding.bottom,            r = Math.min(w, h)/2,            rotation = 0,            oldrotation = 0,            picked = 100000,            oldpick = [],            color = d3.scale.category20();
 // 接口数据映射成转盘数据（增加偏移量字段）
 
  var wheelPopupData = responseWheelPopupData.map(function(item, idx) {
    return {
      id: item.id,
      title: item.title,
      sub_title: item.sub_title || "",
      image: item.image || null,
      // 针对不同扇区单独设置偏移量
      titleOffsetX: idx === 0 ? -5 : 0,
      titleOffsetY: idx === 0 ? -10 : 0,
      subTitleOffsetX: idx === 0 ? -5 : 0,
      subTitleOffsetY: idx === 0 ? 10 : 0,
      imageOffsetX: idx === 0 ? 0 : 0,
      imageOffsetY: idx === 0 ? 0 : 0
    };
  });

  var wheelPopupSvg = d3.select('#spinwheel')
      .append("svg")
      .data([wheelPopupData])
      .attr("xmlns",  "http://www.w3.org/2000/svg")
      .attr('viewBox', '0 0 '+w+' '+w+'')
      .attr("width",  w)
      .attr("class","wheel-round-image")
      .attr("height", h + wheelPopupPadding.top + wheelPopupPadding.bottom);
  var wheelPopupContainer = wheelPopupSvg.append("g")
      .attr("class", "chartholder")
      .attr("transform", "translate(" + (w/2 + wheelPopupPadding.left) + "," + (h/2 + wheelPopupPadding.top) + ")"); //左右距离
  // var vis = container.append("g"); 替换固定角度，设置初始渲染效果偏移 
  var wheelPopupInitialOffset = -30; // 你想整体偏移的角度，正值为顺时针
  var wheelPopupVis = wheelPopupContainer.append("g")
    .attr("transform", "rotate(" + wheelPopupInitialOffset + ")");

  var wheelPopupPie = d3.layout.pie().sort(null).value(function(d){return 1;});
  var wheelPopupArc = d3.svg.arc().outerRadius(r);
  // 扇形区 g标签
  var arcs = wheelPopupVis.selectAll("g.slice")
      .data(wheelPopupPie)
      .enter()
      .append("g")
      .attr("class", "slice slice-trapezoid");
  // 扇形区 path标签
  arcs.append("path")
      .attr("fill", function(d, i){ return color(i); })
      .attr("d", function (d) { return wheelPopupArc(d); });
  // 扇形区 text标签
  arcs.each(function(d, i) {
    const g = d3.select(this);
    const sectorData = wheelPopupData[i];
    const angle = (d.startAngle + d.endAngle) / 2;
    const radius = r * 0.75;
    const baseX = radius * Math.cos(angle - Math.PI / 2);
    const baseY = radius * Math.sin(angle - Math.PI / 2);
  
    if (sectorData.image) {
      // 有图片
      g.append("image")
        .attr("xlink:href", sectorData.image)
        .attr("x", baseX - 20 + sectorData.imageOffsetX)
        .attr("y", baseY - 20 + sectorData.imageOffsetY)
        .attr("width", 40)
        .attr("height", 40)
        .attr("class","wheel-popup-img-title");
    } else {
      // 主标题
      g.append("text")
        .attr("x", baseX + sectorData.titleOffsetX)
        .attr("y", baseY - 8 + sectorData.titleOffsetY)
        .attr("text-anchor", "middle")
        .attr("font-size", "14px")
        .attr("fill", "#fff")
        .attr("class","wheel-popup-title")
        .text(sectorData.title);
  
      // 副标题
      if (sectorData.sub_title) {
        g.append("text")
          .attr("x", baseX + sectorData.subTitleOffsetX)
          .attr("y", baseY + 10 + sectorData.subTitleOffsetY)
          .attr("text-anchor", "middle")
          .attr("font-size", "12px")
          .attr("class","wheel-popup-sub-title")
          .attr("fill", "#fff")
          .text(sectorData.sub_title);
      }
    }
  });

  // 添加粉色指针标记
  wheelPopupContainer.append("circle")
      .attr("cx", 0)
      .attr("cy", -r)
      .attr("r", 5)
      .attr("fill", "pink")
      .attr("id", "pointer-mark");


  // 自动旋转
    let spinning = false;
    let spinRAF = null;
    let angle = 0;
    // 转盘开始
    function startWheelSpin(speedDegPerFrame = 20) {
      // $('#wheel-poupop-spin').prop('disabled', true);
      spinning = true;
      // 执行一个坐标偏移
      const wheelPoupopSpinArrow = $('.sunber-wheel-poupop-con .wheel-spin-arrow svg')
      if (wheelPoupopSpinArrow) {
        wheelPoupopSpinArrow.css('transform','skewX(5deg)')
        // wheelPoupopSpinAeeow.css('transition',' transform 0.3s ease')
      }
      function loop() {
        if (spinning){
          angle = (angle + speedDegPerFrame) % 360;
          wheelPopupVis.attr("transform", `rotate(${angle})`);
          spinRAF = requestAnimationFrame(loop);

        };
      }
      loop();
    }
    // 转盘结束
    window.stopWheelSpin = function() {
      spinning = false;
      // 执行一个坐标偏移恢复
      const wheelPoupopSpinArrow = $('.sunber-wheel-poupop-con .wheel-spin-arrow svg')
      if (wheelPoupopSpinArrow) {
        wheelPoupopSpinArrow.css('transform','skewX(0deg)')
      }
      if (spinRAF) cancelAnimationFrame(spinRAF);
      // $('#wheel-poupop-spin').prop('disabled', false);
      console.log('🛑 转盘已停止');
    };
  // 接收转盘中奖结果，使用动态结果
  function wheelPopupBindSpinClick(){
      $('#wheel-poupop-spin').on("click", function(){
        console.log("更换转盘指针图片");
        console.log('执行了侧边显示1726');
       $('.sunber-wheel-poupop-con-sidebar').show();
        // $('.sunber-wheel-poupop-con .wheel-spin-arrow img').attr('src', 'https://example.com/new-image.png');
        // 触发点击，先验证输入内容
        // const emailInput = $('.wheel-poupop-position-round .round-input-email').val
        // 读取eiail输入框内容
        const emailInput = $('.wheel-poupop-position-round .round-input-email').val().trim();
        // 电话区号
        const phoneInputCode = $('.wheel-poupop-position-round .phone-input .code').text().trim();
        // 读取电话号输入框内容
        const phoneInput = $('.wheel-poupop-position-round .round-number-input .phone-number-input').val().trim();
        console.log("拿到电话区号+内容",phoneInputCode,'+',phoneInput);
        
        // 邮箱正则校验
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // 简单国际手机号正则
        const phoneReg = /^\+?[1-9]\d{6,14}$/;

        let isValid = true; // 标记是否通过校验

        // if (!emailInput) {
        //   // alert('请输入邮箱地址');
        //   // $('.wheel-poupop-position-round .pos-round-error-alter').addClass('pos-round-error-alter-block')
        //   $('.wheel-poupop-position-round .pleaseprovideavalidemailaddress_span').text('Please provide a valid email address.'); 
        //   $('.wheel-poupop-position-round .pos-round-error-alter')
        //     .addClass('pos-round-error-alter-block') // 添加类，显示出来
        //     .show(); // 确保 display 被设为 block（如果类里没设的话）

        //   // 3秒后移除类并隐藏
        //   setTimeout(function () {
        //     $('.wheel-poupop-position-round .pos-round-error-alter')
        //       .removeClass('pos-round-error-alter-block')
        //       .hide();
        //   }, 3000);
        //   return;
        // }
        
        if (!emailInput||!emailPattern.test(emailInput)) {
          isValid = false;
          // alert('邮箱格式不正确');
          $('.wheel-poupop-position-round .pleaseprovideavalidemailaddress_span').text('Please provide a valid email address.'); 
          $('.wheel-poupop-position-round .pos-round-error-alter')
            .addClass('pos-round-error-alter-block') // 添加类，显示出来
            .show(); // 确保 display 被设为 block（如果类里没设的话）

          // 3秒后移除类并隐藏
          setTimeout(function () {
            $('.wheel-poupop-position-round .pos-round-error-alter')
              .removeClass('pos-round-error-alter-block')
              .hide();
          }, 3000);
          return;
        }
        // 校验手机号
        if (phoneInput) {
          if (!phoneReg.test(phoneInput)) {
            isValid = false;
            console.log("手机号不正确");
            $('.wheel-poupop-position-round .pleaseprovideavalidemailaddress_span').text('Please enter a valid iphone.'); 
            $('.wheel-poupop-position-round .pos-round-error-alter')
              .addClass('pos-round-error-alter-block') // 添加类，显示出来
              .show(); // 确保 display 被设为 block（如果类里没设的话）
            // 3秒后移除类并隐藏
            setTimeout(function () {
              $('.wheel-poupop-position-round .pos-round-error-alter')
                .removeClass('pos-round-error-alter-block')
                .hide();
            }, 5000);
            return;
          }
        }


        // 请求结果接口
        // 获取转盘id 和 email 发送后端
         // 把数据 转盘 id 从会话窗口中拿出
        let res2 = sessionStorage.getItem("popuManageResponse");
        if (res2) {
            let obj = JSON.parse(res2); // 转回对象
          console.log("📦 存储的数据为：", obj.data);
        }else{
            console.log('data打印',res2);

        }
        let obj2 = JSON.parse(res2);
        // const waitingTime =obj.length[0].content.pop_seconds
        const activity_id = obj2.data[0].content.reward_activity_id
        // const pop_seconds = obj2.data[0].content.pop_seconds
        console.log("打印会话存储的id供抽奖接口使用✅",activity_id,"邮箱：",emailInput);
        // console.log("打印会话存储的时间✅",pop_seconds);
        
         // 如果都通过校验，才发起请求
        const email = emailInput;
        const phone = phoneInputCode + phoneInput;
        console.log('打印获取电话号',phone);
        if (isValid) {
          if (phoneInput) {
            // 请求之前更换转盘指针图片
            $('.sunber-wheel-poupop-con .wheel-spin-box .wheel-spin-arrow img').attr('src', 'https://cdn.shopify.com/s/files/1/1720/3969/files/Frame_2085663251.png?v=1756170860');
            // 通过前端简单验证去请求 抽奖结果接口 
              lotteryStart(activity_id,email,phone)
          }else{
            // 请求之前更换转盘指针图片
            $('.sunber-wheel-poupop-con .wheel-spin-box .wheel-spin-arrow img').attr('src', 'https://cdn.shopify.com/s/files/1/1720/3969/files/Frame_2085663251.png?v=1756170860');
            // 通过前端简单验证去请求 抽奖结果接口 
              lotteryStart(activity_id,email)
          }
        }




        // 自动旋转
        startWheelSpin();  
      });
  }

  $(document).ready(function(){
      wheelPopupBindSpinClick();
  });

  function wheelPopupRotTween() {
      var i = d3.interpolate(oldrotation % 360, rotation);
      return function(t) {
          return "rotate(" + i(t) + ")";
      };
  }

  wheelPopupContainer.append("circle")
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", 110.86)
      .attr("class", "circle-wheel-poupop")   
      .style({"fill":"#ffffff","stroke":"#F79009","stroke-width":"1" });

  function wheelPopupGetRandomNumbers(){
      var array = new Uint16Array(1000);
      var scale = d3.scale.linear().range([360, 1440]).domain([0, 100000]);
      if(window.hasOwnProperty("crypto") && typeof window.crypto.getRandomValues === "function"){
          window.crypto.getRandomValues(array);
          console.log("works");
      } else {
          for(var i=0; i < 1000; i++){
              array[i] = Math.floor(Math.random() * 100000) + 1;
          }
      }
      return array;
  }

  
  wheelPopupNumber(".sunber-wheel-poupop-con .round-number-input");
}

  function wheelPopupNumber(containerSelector) {
    const numberCountries = [
      { name: "USA", code: "+1", flag: "https://flagcdn.com/us.svg" },
      { name: "UK", code: "+44", flag: "https://flagcdn.com/gb.svg" },
      { name: "France", code: "+33", flag: "https://flagcdn.com/fr.svg" },
      { name: "China", code: "+86", flag: "https://flagcdn.com/cn.svg" },
      { name: "Japan", code: "+81", flag: "https://flagcdn.com/jp.svg" },
      { name: "Germany", code: "+49", flag: "https://flagcdn.com/de.svg" },
      { name: "Italy", code: "+39", flag: "https://flagcdn.com/it.svg" },
      { name: "India", code: "+91", flag: "https://flagcdn.com/in.svg" },
      { name: "Russia", code: "+7", flag: "https://flagcdn.com/ru.svg" },
      { name: "Australia", code: "+61", flag: "https://flagcdn.com/au.svg" }
    ];
  
    const container = document.querySelector(containerSelector);
    if (container) {
      const customSelect = container.querySelector(".custom-select");
      const optionsList = container.querySelector(".options");
      const selectedFlag = customSelect.querySelector(".selected-flag img");
      const selectedCode = customSelect.querySelector(".selected-flag .code");
      const arrow = customSelect.querySelector(".arrow");
    
      // 清空旧的 options，避免重复初始化
      optionsList.innerHTML = "";
    
      numberCountries.forEach(c => {
        const option = document.createElement("div");
        option.classList.add("option");
        option.innerHTML = `
          <img src="${c.flag}" alt="${c.name}">
          <span>${c.name}</span>
          <strong>${c.code}</strong>
        `;
        option.addEventListener("click", () => {
          selectedFlag.src = c.flag;
          selectedFlag.alt = c.name;
          selectedCode.textContent = c.code;
          optionsList.style.display = "none";
          arrow.classList.remove("open");
        });
        optionsList.appendChild(option);
      });
    
      customSelect.addEventListener("click", (e) => {
        e.stopPropagation(); // 阻止冒泡，避免触发外部点击事件
        const isOpen = optionsList.style.display === "block";
        optionsList.style.display = isOpen ? "none" : "block";
        arrow.classList.toggle("open", !isOpen);
      });
    
      document.addEventListener("click", () => {
        optionsList.style.display = "none";
        arrow.classList.remove("open");
      });

    };
  
  }
  
// 券列表的监听

var $target = $('.all-voucher-package-con ');
var $label = $('.all-voucher-package-con .down_time_label_right');
var storageKey = 'row1_expire_time';
var timer = null;

// ===== 更新显示到 DOM（分钟 / 秒 分开）=====
function updateLabel(ms) {
  var totalSec = Math.max(0, Math.floor(ms / 1000));
  var m = Math.floor(totalSec / 60);
  var s = totalSec % 60;

  // 拼接成两个 span
  var html = '<span class="time-min">' + (m < 10 ? "0" + m : m) + '</span>'
           + '<span class="time-colon">:</span>'
           + '<span class="time-sec">' + (s < 10 ? "0" + s : s) + '</span>';

  $label.html(html);
}

// ===== 启动倒计时 =====
function startCountdown(expireAt) {
  function tick() {
    var remain = expireAt - Date.now();
    if (remain > 0) {
      updateLabel(remain);
    } else {
      clearInterval(timer);
      updateLabel(0);
      console.log("✅ 倒计时结束，执行逻辑");
      // 👉 倒计时结束逻辑写这里
      $('.sunber-wheel-poupop-con-sidebar').css('display','none');
      $('.all-voucher-package-enter-slider').css('display','none');
      $('.all-voucher-package-con').css('display','none')
      sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
      sessionStorage.setItem("threeHundredVoucherPackageGetItClose", "true");
    }
  }
  tick(); // 立即执行一次
  timer = setInterval(tick, 1000);
}

// ===== 页面刷新时恢复倒计时 券包弹窗倒计时=====
var expireTime = sessionStorage.getItem(storageKey);
if (expireTime) {
  expireTime = parseInt(expireTime, 10);
  var remain = expireTime - Date.now();
  if (remain > 0) {
    console.log("⏳ 恢复倒计时，剩余:", Math.round(remain / 1000), "秒");
    startCountdown(expireTime);
  } else {
    console.log("✅ 已经过了5分钟，直接执行逻辑");
    $('.all-voucher-package-enter-slider').css('display','none');
    $('.all-voucher-package-con').css('display','none');
    $('.sunber-wheel-poupop-con-sidebar').css('display','none')
    sessionStorage.setItem("threeHundredVoucherPackageGetItClose", "true");
    // 做一个 300 成功 && 时间未结束 判断  ，不符合条件执行 close true 

    // 做一个注册成功+转盘 成功 &&时间未结束 判断 不符合条件 执行  close + get true

    updateLabel(0);
    // 👉 这里写倒计时已过期的逻辑
  }
}

// ===== MutationObserver 监听 券包弹窗倒计时=====
if ($target.length) {
  var observer = new MutationObserver(function (mutations) {
    console.log("👀 MutationObserver 触发了:", mutations);

    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        var display = $target.css('display');
        console.log("属性变化:", mutation.attributeName, " 当前 display:", display);

        if (display === 'block' && !sessionStorage.getItem(storageKey)) {
          console.log('🎉 元素第一次显示，启动5分钟倒计时');
          var expireAt = Date.now() + 5 * 60 * 1000; // 👉 改这里调整时间
          sessionStorage.setItem(storageKey, expireAt);
          startCountdown(expireAt);

          // sessionStorage.setItem("threeHundredVoucherPackageGetItClose", "true");


        }
      }
    });
  });

  observer.observe($target[0], {
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  console.log("✅ 已经开始监听 .row1 的属性变化");
} else {
  console.log("❌ 没找到目标元素 .row1");
}


// ==++==倒计时公共方法==++==
function setRegisterCountdown(minutes = 5) {
  const endTime = Date.now() + minutes * 60 * 1000;
  sessionStorage.setItem("register_bonus_end_time", endTime);
  console.log("注册成功，倒计时结束时间存储：", new Date(endTime).toLocaleTimeString());

  // 启动倒计时
  runRegisterCountdown();
}


function runRegisterCountdown() {
  const endTime = parseInt(sessionStorage.getItem("register_bonus_end_time"), 10);

  if (!endTime || isNaN(endTime)) {
    console.log("没有注册倒计时，不执行");
    return;
  }

  function tick() {
    const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));

    if (remaining > 0) {
      console.log(`注册奖励倒计时：剩余 ${remaining} 秒`);
      setTimeout(tick, 5000);
    } else {
      console.log("注册奖励倒计时结束 🎉");
      sessionStorage.removeItem("register_bonus_end_time");

      // ⚡ 这里写到期逻辑
      $('.sunber-wheel-poupop-con-sidebar').hide();
      $('.sunber-wheel-poupop-con').hide();
      sessionStorage.setItem("threeHundredVoucherPackageGetIt", "true");
      sessionStorage.setItem("threeHundredVoucherPackageGetItClose", "true");
    }
  }

  tick();
}




})